module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1a375f587f65a466438a7e60100a8750.png";